module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "position-back"
  }, [_c('div', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Previous step")])])])]), _vm._m(1), _c('div', {
    staticClass: "column mb-20"
  }, [_c('div', {
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.filteredAlgos), function(o) {
    return (!o.deactivated) ? _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "box-container"
    }, [_c('div', {
      staticClass: "element-box-container",
      on: {
        "click": function($event) {
          return _vm.select(o)
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.name))]), _c('br'), _c('div', {
      staticClass: "is-flex jcc aic"
    }, [_c('div', {
      staticClass: "algo-image"
    }, [_c('img', {
      attrs: {
        "src": o.symbolLogo,
        "alt": o.symbol + ' logo'
      }
    })]), _c('div', {
      staticClass: "symbol-container"
    }, [_c('span', [_vm._v(_vm._s(o.symbol) + " based")]), (o.minimumVramRequirement) ? _c('span', {
      staticClass: "minimun"
    }, [_vm._v("> " + _vm._s(o.minimumVramRequirement) + " GPU")]) : _vm._e()])])])])]) : _vm._e()
  }), 0)]), _c('div', {
    staticClass: "feature-helvetica step-explanation"
  }, [_vm._m(2), _c('div', {
    staticClass: "articles"
  }, [_c('router-link', {
    staticClass: "article-mini",
    attrs: {
      "to": "/support/article/what-are-the-minimum-requirements-for-mining",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "article-inner"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('span', [_vm._v(" What are the minimum requirements for mining?")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Select your mining algorithm")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-10"
  }, [_c('span', [_vm._v("Be sure to meet the minimum hardware requirements (VRAM memory size) for the algorithm that you select.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20af0c29","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_step_algorithm.vue
// module id = 365
// module chunks = 1